import { useWindowDimensions } from "react-native";

/**
 * The OS font scale from which fixed-size text boxes give way to their content: iOS's largest
 * standard size (1.353) and every accessibility size, and Android's 1.3 and above.
 */
export const LARGE_TEXT_SCALE = 1.3;

/** True while the person's text-size setting is at or above `LARGE_TEXT_SCALE`. Always false on web. */
export function useLargeText(): boolean {
  return useWindowDimensions().fontScale >= LARGE_TEXT_SCALE;
}
